var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecomDenoter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18801",
    "data-name": "Group 18801",
    transform: "translate(11027 -691)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(-11027 691)",
    fill: "#f2f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "warning-sign-9773",
    transform: "translate(-11023.02 695.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M10.188,20.376A10.188,10.188,0,1,1,20.376,10.188,10.2,10.2,0,0,1,10.188,20.376Z",
    transform: "translate(0.332)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18800",
    "data-name": "Group 18800",
    transform: "translate(0.345 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M109.877,56.689h0a.89.89,0,0,1-.956-.736l-.882-6.853a1.659,1.659,0,0,1,1.838-1.595h0a1.659,1.659,0,0,1,1.838,1.595l-.882,6.853A.889.889,0,0,1,109.877,56.689Z",
    transform: "translate(-99.702 -43.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    cx: 1.727,
    cy: 1.727,
    r: 1.727,
    transform: "translate(8.332 14.094)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecomDenoter);
export default __webpack_public_path__ + "static/media/recom-denoter.c19ee28b76e5d01b33474ecded64ab20.svg";
export { ForwardRef as ReactComponent };